import createSvgIcon from '../Utils/CreateSvgIcon';

export const CustomerService = createSvgIcon(
  <>
    <path
      d="M12 20a6 6 0 0 0 6-6V9A6 6 0 1 0 6 9v2.5M18 9h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2V9ZM6 9H4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h2V9Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle cx="12" cy="20" fill="currentColor" r="2" />
  </>,
  'CustomerService',
);
